import { useCallback } from 'react';
import { useAppSelector } from '../Redux/hooks';
import { useTranslation } from '../i18n/useTranslation';
import { displayNameOf } from './DisplayNameUtil';

/**
 * The spelling to show for a bare student name.
 *
 * Lessons, debts, reminders and calendar entries carry a student's identity
 * rather than the student, so a screen showing one has only the name to go on
 * and has to look the card up to find out how this reader should read it.
 *
 * Deliberately not used for documents. A receipt and a payment request are
 * made out to somebody, and the name on them is a stored snapshot of what was
 * already sent; re-rendering that in whatever language the tutor happens to be
 * reading in would misstate a record. Those screens keep showing exactly what
 * the document says.
 */
export function useDisplayName(): (name: string) => string {
  const { language } = useTranslation();
  const students = useAppSelector(state => state.students.items);
  return useCallback(
    (name: string) => displayNameOf(name, students, language),
    [students, language]
  );
}
